import { render, staticRenderFns } from "./LicenseKanban.vue?vue&type=template&id=210a1374&scoped=true&"
import script from "./LicenseKanban.vue?vue&type=script&lang=js&"
export * from "./LicenseKanban.vue?vue&type=script&lang=js&"
import style0 from "./LicenseKanban.vue?vue&type=style&index=0&id=210a1374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a1374",
  null
  
)

export default component.exports